import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {WithdrawRoutingModule} from './withdraw-routing.module';
import {WithdrawComponent} from './components/withdraw/withdraw.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {FormsModule} from '@angular/forms';
import {
  NbAccordionModule,
  NbBadgeModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import { WithdrawRialComponent } from './components/withdraw-rial/withdraw-rial.component';
import { TableModule } from 'primeng/table';
import { CallOnWithdrawPipe } from './pipes/call-on-withdraw.pipe';
import { ToQrCodePipe } from './pipes/to-qr-code.pipe';
import {DepositTypePipe} from './pipes/deposit-type.pipe';

@NgModule({
  declarations: [
    WithdrawComponent,
    WithdrawRialComponent,
    CallOnWithdrawPipe,
    ToQrCodePipe,
    DepositTypePipe
  ],
  exports: [DepositTypePipe],
  imports: [
    CommonModule,
    WithdrawRoutingModule,
    SharedModule,
    Ng2SmartTableModule,
    FormsModule,
    TableModule,
    NbSpinnerModule,
    NbTooltipModule,
    NbToggleModule,
    NbAccordionModule,
    NbTabsetModule,
    NbBadgeModule,
    TableModule
  ]
})
export class WithdrawModule {
}
